import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styles from './PaymentResult.module.css';

const STORAGE_SESSION_KEY = 'checkout_session_id';
const STORAGE_AMOUNT_KEY = 'checkout_amount';

const PaymentFailure: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const paramMessage = searchParams.get('message') || undefined;

  const [message, setMessage] = useState<string>(paramMessage || 'Payment was not completed.');
  const [amount, setAmount] = useState<string | undefined>(undefined);
  const [sessionId, setSessionId] = useState<string | undefined>(undefined);

  useEffect(() => {
    const storedSession = localStorage.getItem(STORAGE_SESSION_KEY);
    const storedAmount = localStorage.getItem(STORAGE_AMOUNT_KEY);
    if (storedSession) setSessionId(storedSession);
    if (storedAmount) setAmount(storedAmount);

    return () => {
      try {
        localStorage.removeItem(STORAGE_SESSION_KEY);
        localStorage.removeItem(STORAGE_AMOUNT_KEY);
      } catch (e) {}
    };
  }, []);

  const handleTryAgain = () => {
    try {
      localStorage.removeItem(STORAGE_SESSION_KEY);
      localStorage.removeItem(STORAGE_AMOUNT_KEY);
    } catch (e) {}
    navigate(-1);
  };

  const handleGoHome = () => {
    try {
      localStorage.removeItem(STORAGE_SESSION_KEY);
      localStorage.removeItem(STORAGE_AMOUNT_KEY);
    } catch (e) {}
    navigate('/');
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={`${styles.iconCircle} ${styles.failure}`}>✕</div>
        <div>
          <h2 className={styles.title}>Payment failed</h2>
          <div className={styles.subtitle}>There was an issue processing your payment.</div>
        </div>
      </div>

      <div className={styles.body}>
        <div className={styles.left}>
          <p className={styles.muted}>{message}</p>
          <div className={styles.card} style={{marginTop:12}}>
            {amount && <div className={styles.metaItem}><strong>Amount:</strong> <span className={styles.largeAmount}>${amount}</span></div>}
            {sessionId && <div className={styles.metaItem}><strong>Session:</strong> <span className={styles.muted}>{sessionId}</span></div>}
            <div className={styles.metaItem}><strong>Next steps:</strong></div>
            <ul style={{marginTop:8, paddingLeft:18}}>
              <li>Check your card details and try again.</li>
              <li>Use a different payment method or card.</li>
              <li>Contact support if the issue persists.</li>
            </ul>
          </div>

          <div className={styles.btnRow}>
            <button className={styles.primaryBtn} onClick={handleTryAgain}>Try again</button>
            <button className={styles.secondaryBtn} onClick={handleGoHome}>Go to Home</button>
          </div>
        </div>

        <div className={styles.right}>
          <div className={styles.card}>
            <div style={{fontSize:12,color:'#666'}}>Support</div>
            <div style={{marginTop:8,fontSize:13,color:'#333'}}>If you need help, contact our support team with details of the transaction.</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailure;
